import * as Api from '@ViewModels';
import { useRegEdIntegrationQuery } from './useRegEdIntegrationQuery';

/**
 * Fail-closed compliance gate: true only when the integration is enabled AND fully configured, and
 * deliberately false while loading or on error — an unresolved state must never route through RegEd.
 */
export const useAccountUsesRegEd = (
	impersonationContext?: Api.IImpersonationContext,
	{ enabled = true }: { enabled?: boolean } = {}
): boolean => {
	const { data } = useRegEdIntegrationQuery({ impersonationContext, enabled });
	return data?.enabled === true && data?.configurationStatus?.needsConfiguration === false;
};
